import { useEffect } from "react";

/**
 * Lightweight SEO helper for a CRA SPA — sets document title, meta description,
 * Open Graph / Twitter tags and a canonical link per route. No external deps.
 */
export default function Seo({ title, description, path, image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Studivault` : "Studivault — AI Study Tool";
    document.title = fullTitle;

    setMetaName("description", description);
    setMetaProp("og:title", fullTitle);
    setMetaProp("og:description", description);
    setMetaProp("og:type", "website");
    setMetaName("twitter:title", fullTitle);
    setMetaName("twitter:description", description);
    if (image) {
      setMetaProp("og:image", image);
      setMetaName("twitter:image", image);
      setMetaName("twitter:card", "summary_large_image");
    }

    const base = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/+$/, "");
    const url = `${base}${path || window.location.pathname}`;
    setMetaProp("og:url", url);
    setCanonical(url);
  }, [title, description, path, image]);

  return null;
}

function setMetaName(name, content) {
  if (!content) return;
  let m = document.querySelector(`meta[name="${name}"]`);
  if (!m) { m = document.createElement("meta"); m.setAttribute("name", name); document.head.appendChild(m); }
  m.setAttribute("content", content);
}
function setMetaProp(prop, content) {
  if (!content) return;
  let m = document.querySelector(`meta[property="${prop}"]`);
  if (!m) { m = document.createElement("meta"); m.setAttribute("property", prop); document.head.appendChild(m); }
  m.setAttribute("content", content);
}
function setCanonical(href) {
  let l = document.querySelector('link[rel="canonical"]');
  if (!l) { l = document.createElement("link"); l.setAttribute("rel", "canonical"); document.head.appendChild(l); }
  l.setAttribute("href", href);
}
